/* eslint-disable @typescript-eslint/no-explicit-any */
import { VStack, Text, Box } from '@chakra-ui/react';
import { getDiscounts } from '@partiu/api/dashboard/api';
import React, { useEffect } from 'react';
import Select from 'react-select';

export const PromotionInput = ({
  setValue,
}: {
  discount: any;
  setValue: (name: any, value: any) => void;
}) => {
  const [promotions, setPromotions] = React.useState<any[]>([]);

  const handleGetPromotions = async (search?: string) => {
    const response = await getDiscounts(search);
    setPromotions(response.results);
  };

  useEffect(() => {
    handleGetPromotions();
  }, []);

  return (
    <VStack width={'100%'} paddingY={2} alignItems={'flex-start'}>
      <Text fontWeight={'bold'}>Vincular Promoção</Text>
      <Box
        width="100%"
        maxWidth={{
          base: '100%',
          md: '300px',
        }}
      >
        <Select
          isSearchable
          isClearable
          onChange={(selectedOption) => setValue('discount', selectedOption)}
          onInputChange={(text) => {
            if (text && text !== '') {
              handleGetPromotions(text);
            }
          }}
          options={promotions.map((prom) => ({
            value: prom.id,
            label: prom.full_name,
          }))}
        />
      </Box>
    </VStack>
  );
};
